import { WizardEventPageModule } from './../pages/wizard-event/wizard-event.module';
import { WizardEventPage } from './../pages/wizard-event/wizard-event.page';
import { TranslateModule } from '@ngx-translate/core';
import { SchedulerComponent } from './../components/scheduler/scheduler.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { FolderPageRoutingModule } from './folder-routing.module';

import { FolderPage } from './folder.page';
import { SettingsComponent } from '../components/settings/settings.component';
import { EventComponent } from '../components/settings/event/event.component';
import { CompanyComponent } from '../components/settings/company/company.component';
import { EmailingComponent } from '../components/settings/emailing/emailing.component';
import { LocationComponent } from '../components/settings/location/location.component';
import { EventtypelistComponent } from '../components/settings/_lists/eventtypelist/eventtypelist.component';
import { MaillistlistComponent } from '../components/settings/_lists/maillistlist/maillistlist.component';
import { LocationlistComponent } from '../components/settings/_lists/locationlist/locationlist.component';
import { UserComponent } from '../components/settings/user/user.component';
import { UserlistComponent } from '../components/settings/_lists/userlist/userlist.component';
import { WizardQuestionListComponent } from '../components/settings/_lists/wizard-question-list/wizard-question-list.component';
import { WizardQuestionEditComponent } from '../components/settings/wizard-question-edit/wizard-question-edit.component';
import { SwiperModule } from 'swiper/angular';



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FolderPageRoutingModule,
    TranslateModule,
    WizardEventPageModule,
    SwiperModule
  ],
  declarations: [
    FolderPage,
    SettingsComponent,
    SchedulerComponent,
    CompanyComponent,
    EventComponent,
    CompanyComponent,
    LocationComponent,
    EventtypelistComponent,
    EmailingComponent,
    MaillistlistComponent,
    LocationlistComponent,
    UserComponent,
    UserlistComponent,
    WizardQuestionListComponent,
    WizardQuestionEditComponent
  ]
})
export class FolderPageModule { }
